export default "/packs/images/gym-workout~3cb73468c4f156e0b9986922c16dbb1c.jpg";